import PropTypes from "prop-types";
import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import SIXYARD from "../../assets/container_icons/6YARD.png";
import EIGHTYARD from "../../assets/container_icons/8YARD.png";
import TENYARD from "../../assets/container_icons/10YARD.png";
import BAGS from "../../assets/container_icons/BAGS.png";
import TWOFORTYLTR from "../../assets/container_icons/240LTR.png";
import THREESIXTYLTR from "../../assets/container_icons/360LTR.png";
import SIXSIXTYLTR from "../../assets/container_icons/660LTR.png";
import SEVENSEVENTYLTR from "../../assets/container_icons/770LTR.png";
import THOUSANDONEHUNDREDLTR from "../../assets/container_icons/1100LTR.png";
import MandV from "../../assets/container_icons/M&V.png";
import RORO from "../../assets/container_icons/RORO.png";

import ONEFORTYLTR from "../../assets/container_icons/140LTR.png";
import TWELVEYARDREL from "../../assets/container_icons/12YARDREL.png";
import FOURTEENYARDREL from "../../assets/container_icons/14YARDREL.png";
import SKIP from "../../assets/container_icons/SKIP.png";

const ContainerIcon = ({ containerType }) => {
  const containerTypeIconLookup = {
    "50BAGS": <LazyLoadImage src={BAGS} className="h-full" />,
    "240LTR": <LazyLoadImage src={TWOFORTYLTR} className="h-full" />,
    "260LTR": <LazyLoadImage src={TWOFORTYLTR} className="h-full" />,
    "360LTR": <LazyLoadImage src={THREESIXTYLTR} className="h-full" />,
    "660LTR": <LazyLoadImage src={SIXSIXTYLTR} className="h-full" />,
    "770LTR": <LazyLoadImage src={SEVENSEVENTYLTR} className="h-full" />,
    "1100LTR": <LazyLoadImage src={THOUSANDONEHUNDREDLTR} className="h-full" />,
    "M&V": <LazyLoadImage src={MandV} className="h-full" />,

    "1280LTR": <LazyLoadImage src={THOUSANDONEHUNDREDLTR} className="h-full" />,
    "140LTR": <LazyLoadImage src={ONEFORTYLTR} className="h-full" />,
    "6YARDFEL": <LazyLoadImage src={SIXYARD} className="h-full" />,
    "8YARDFEL": <LazyLoadImage src={EIGHTYARD} className="h-full" />,
    "10YARDFEL": <LazyLoadImage src={TENYARD} className="h-full" />,
    "10YARDREL": <LazyLoadImage src={SKIP} className="h-full" />,
    "12YARDREL": <LazyLoadImage src={TWELVEYARDREL} className="h-full" />,
    "14YARDREL": <LazyLoadImage src={FOURTEENYARDREL} className="h-full" />,
    "20YARDRORO": <LazyLoadImage src={RORO} className="h-full" />,
    "25YARDRORO": <LazyLoadImage src={RORO} className="h-full" />,
    "35YARDRORO": <LazyLoadImage src={RORO} className="h-full" />,
    "40YARDRORO": <LazyLoadImage src={RORO} className="h-full" />,
    "2YARDSKIP": <LazyLoadImage src={SKIP} className="h-full" />,
    "3YARDSKIP": <LazyLoadImage src={SKIP} className="h-full" />,
    "4YARDSKIP": <LazyLoadImage src={SKIP} className="h-full" />,
    "5YARDSKIP": <LazyLoadImage src={SKIP} className="h-full" />,
    "6YARDSKIP": <LazyLoadImage src={SKIP} className="h-full" />,
    "8YARDSKIP": <LazyLoadImage src={SKIP} className="h-full" />,
    "10YARDSKIP": <LazyLoadImage src={SKIP} className="h-full" />,
    "12YARDSKIP": <LazyLoadImage src={SKIP} className="h-full" />,
  };
  return <>{containerTypeIconLookup[containerType]}</>;
};
ContainerIcon.propTypes = {
  containerType: PropTypes.string.isRequired,
};
export default ContainerIcon;
